export const includeReg = /\{%\s*include\s+['"](?<reference>.*)['"]\s*%\}/;
